import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const getConfig = async () => (await http.get("/config")).data;
export const createOrder = async (payload) => (await http.post("/orders", payload)).data;
export const verifyPayment = async (payload) => (await http.post("/payments/verify", payload)).data;
export const sendContact = async (payload) => (await http.post("/contact", payload)).data;

// ---- Admin ----
export const adminLogin = async (email, password) =>
  (await http.post("/auth/login", { email, password })).data;

export const getAdminOrders = async (token) =>
  (await http.get("/admin/orders", { headers: { Authorization: `Bearer ${token}` } })).data;

export const getAdminStats = async (token) =>
  (await http.get("/admin/stats", { headers: { Authorization: `Bearer ${token}` } })).data;

export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}
